import { createApp } from 'vue'
import App from '@/page/vue/2024/event/camping.vue'
import '@/styles/index.scss'
import initShare from '@/utils/wxShare.js'
import { Swipe, SwipeItem } from 'vant'
import 'vant/lib/index.css'
import tongji from '@/utils/tongji.js'; //引入统计

import Qapm from '@q/qapm';
Qapm('init', {
    appKey: 'isc',
    env: import.meta.env.MODE,
    ratio: 100,
});

tongji(); //统计
initShare({
  title: '燃爆安全和AI双赛道，ISC训练营开启报名!',
  desc: 'ISC.AI 2024全新培训板块，7月30日北京开营，立即咨询报名！',
  imgUrl: 'https://p2.ssl.qhimg.com/t11b673bcd63d08757e69e579bc.png',
  link: window.location.href
})


const app = createApp(App)
app.use(Swipe)
app.use(SwipeItem)
app.mount('#app')
